module.exports = __webpack_public_path__ + "static/cosycolour7-87d10cd1afffd542e6c77ca51fbec0dd.png";